import { EVENTS_NEW_REQUEST, EVENTS_SHOW_FOOTER } from '../../../main/constants/events';
import {
    ADD_NOTIFICATION,
    MODAL_CLOSED,
    REMOVE_NOTIFICATION,
    SHOW_CERTIFIED_FILE_MODAL,
    TOGGLE_NEW_REQUEST_MODAL,
    CONFIRM_LEAVE_MODAL_CLOSED,
    HIDE_TRIAL_BAR,
    HIDE_FIXED_NOTIFICATIONS_WRAPPER,
    EventDataTypesActions,
    SET_DASHBOARD_NEW_REQUEST_MODAL,
} from './types';

export const INITIAL_STATE = { notifications: [] };

export default function(state = INITIAL_STATE, action: EventDataTypesActions) {
    switch (action.type) {
        case EVENTS_SHOW_FOOTER:
            return {
                ...state,
                all: action.payload.data,
            };

        case EVENTS_NEW_REQUEST:
            return {
                ...state,
                newRequest: action.payload,
            };

        case ADD_NOTIFICATION:
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        content: action.payload.detail ? action.payload.detail.content : '',
                        variant: action.payload.type,
                        dismissed: false,
                    },
                ],
            };

        case REMOVE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.pop(),
            };

        case MODAL_CLOSED:
            return {
                ...state,
                closeModalEventDetail: action.payload.detail,
            };

        case CONFIRM_LEAVE_MODAL_CLOSED:
            return {
                ...state,
                closeConfirmLeaveModalEventDetail: action.payload.detail,
            };

        case TOGGLE_NEW_REQUEST_MODAL:
            return {
                ...state,
                openNewRequestModal: action.payload.status,
            };

        case SHOW_CERTIFIED_FILE_MODAL:
            return {
                ...state,
                showCertifiedModal: action.payload,
            };

        case HIDE_TRIAL_BAR:
            return {
                ...state,
                hideTrialBar: action.payload.hideTrialBar,
            };

        case SET_DASHBOARD_NEW_REQUEST_MODAL:
            return {
                ...state,
                dashboardNewRequestModal: {
                    ...action.payload,
                },
            };

        case HIDE_FIXED_NOTIFICATIONS_WRAPPER:
            return {
                ...state,
                hideFixedNotificationsWrapper: action.payload.hideFixedNotificationsWrapper,
            };

        default:
            return state;
    }
}
